import { PublicDailyServiceMetrics } from '@/types/service/serviceHealth';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

import { fillMissingDays, getStatusColor } from '@/utils/statusPageHelpers';

interface UptimeChartProps {
  metrics: PublicDailyServiceMetrics[];
}

const UptimeChart = ({ metrics }: UptimeChartProps) => {
  const filledMetrics = fillMissingDays(metrics);

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex items-center justify-between text-xs text-muted-foreground'>
        <span>90 days ago</span>
        <span>Today</span>
      </div>
      <div className='flex items-end gap-[2px] h-12'>
        <TooltipProvider delayDuration={100}>
          {filledMetrics.map((metric, index) => {
            const isNoData = metric === null;
            const colorClasses = isNoData
              ? { bg: 'bg-gray-200', text: 'text-gray-700' }
              : getStatusColor(metric.status);

            return (
              <Tooltip key={index}>
                <TooltipTrigger asChild>
                  <div
                    className={`flex-1 ${colorClasses.bg} rounded-md hover:opacity-80 transition-opacity cursor-pointer h-full`}
                  />
                </TooltipTrigger>
                <TooltipContent side='top' className='max-w-xs'>
                  {isNoData ? (
                    <div className='text-sm'>
                      <p className='font-semibold'>No data</p>
                    </div>
                  ) : (
                    <div className='text-sm'>
                      <p className='font-semibold'>{metric.date}</p>
                    </div>
                  )}
                </TooltipContent>
              </Tooltip>
            );
          })}
        </TooltipProvider>
      </div>
    </div>
  );
};

export default UptimeChart;
